import NextImage from "@components/NextImage";
import {Btn} from "@components/V5Comp";
import {useTranslation} from "@i18n/client";
import React from "react";

import {usePartnersConstants} from "../../../constants/Partners";

const Hero: React.VoidFunctionComponent = () => {
  const i18n = useTranslation();
  const {ctaProps} = usePartnersConstants();

  return (
    <div className="pt46 pb18 pt30-md pb4 bg-lightMint ph4 contrast-tbb">
      <div className="maxw54 ma tac">
        <h1>
          {i18n.t(
            "Partnering with hospitals, specialists, and medical groups to reimagine how healthcare is delivered",
          )}
        </h1>
        <div className="mt10">
          <Btn {...ctaProps} />
        </div>

        <div className="mt30 df jcsb fw jcc-md mt10-md">
          {[
            {src: "jmh", alt: "John Muir Health"},
            {src: "northbay", alt: "NorthBay Healthcare"},
            {src: "prime-master", alt: "Prime Healthcare"},
          ].map(({src, alt}) => (
            <NextImage
              className="mh4 mv2-md"
              key={src}
              src={`partners/${src}`}
              width={220}
              height={50}
              extension="svg"
              alt={alt}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Hero;
